import { GOOGLE_MAPS_KEY } from "../const";

type GoogleMapsEmbedProps = {
  name: string;
  location: string;
  lat: number;
  lon: number;
  zoom?: number;
};

// Zoom 0 = whole world, zoom 21 = individual building
export const GoogleMapsEmbed: React.FC<GoogleMapsEmbedProps> = ({ name, location, lat, lon, zoom = 11 }) => (
  <iframe
    src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_KEY}&zoom=${zoom}&center=${lat},${lon}&q=${encodeURIComponent(
      `${name},${location}`,
    )}`}
    width="100%"
    height="450"
    style={{ border: 0 }}
    title={`Map to ${name}`}
    allowFullScreen
    className="border-radius"
  />
);
